import Loading from 'component/Loading';
import {Suspense, useEffect, useState} from 'react'
import { Link } from 'react-router-dom';

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){

    const [lotto, setLotto] = useState([]);
    
    const fn_getLotto = ()=>{
        const numbers = [];
        for (let i = 1; i <= 45; i++) {
        numbers.push(i);
        }

        // Fisher-Yates 셔플 알고리즘
        for (let i = numbers.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
        }

        // 배열의 처음 6개 요소를 선택
        let arr = numbers.slice(0, 6);
        let len = arr.length;
        for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr.length - i - 1; j++) {
                if (arr[j] > arr[j + 1]) {
                    [arr[j], arr[j + 1]] = [arr[j + 1], arr[j]];
                }
            }
        }
        setLotto(arr);
    }

    const fn_getBackground = (num)=>{
        let background = "gold";

        if(Number(num) <= 10){
            background = "gold";
        }else if(Number(num) > 10 && Number(num) <= 20){
            background = "blue";
        }else if(Number(num) > 20 && Number(num) <= 30){
            background = "red";
        }else if(Number(num) > 30 && Number(num) <= 40){
            background = "gray";
        }else{
            background = "green";
        }


        return background;
    }


    useEffect(()=>{
        fn_getLotto();        
    }, []);

    return (
        <>
            <div className="lotto-wrap">
                {
                    lotto!=null && lotto.length>0 ? (
                        lotto.map((ob, i)=>{
                            return (
                                <div key={i} className="lotto-item">
                                    <span style={{background:fn_getBackground(ob)}}>{ob}</span>
                                </div>
                            );
                        })
                    ) : ''
                }          
            </div>
        </>
    );
}